import { fromJS } from 'immutable'
import {
  SALE_PRODUCT_DELETE_REQUEST,
  SALE_PRODUCT_DELETE_SUCCESS,
  SALE_PRODUCT_DELETE_FAILURE,
  SALE_PRODUCT_DELETE_RESET,
} from '../../actions/sale-product/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SALE_PRODUCT_DELETE_REQUEST:
      return state
        .set('isFetching', true)
    case SALE_PRODUCT_DELETE_SUCCESS:
      return state
        .set('isFetching', false)
        .set('type', 'success')
        .set('status', 'Deleted Successfully')
        .set('message', 'The data had successfully been updated')
        .set('deletedProduct', fromJS(action.payload.deletedProduct))
    case SALE_PRODUCT_DELETE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('type', 'error')
        .set('status', 'Error')
        .set('deletedProduct', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
    case SALE_PRODUCT_DELETE_RESET:
      return state
        .set('isFetching', false)
        .set('type', null)
        .set('status', null)
        .set('deletedProduct', null)
        .set('message', null)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sale-product/sale-product-delete-reducer.js